import React from 'react';
import { Mask, Spinner, Heading } from '@instructure/ui';
const SessionLoaderOverlay = () => {
  return (
    <>
      <Mask
        placement="center"
        fullscreen={true}
        themeOverride={{ zIndex: 7000 }}
      >
        <Spinner renderTitle="Loading" size="large" />
        <Heading color="secondary">Loading</Heading>
      </Mask>
    </>
  );
};

export default SessionLoaderOverlay;
